module.exports = "/images/icon-mute.svg?a58da2adb49d41162e90176f7567cdc8";